import { useState, useEffect } from 'react';
import { fetchMyFeed } from '../../../services/api';

const useMyFeed = (filter = null) => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadFeed = async () => {
      try {
        setLoading(true);
        const data = await fetchMyFeed(filter);
        setJobs(data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadFeed();
  }, [filter]);

  return { jobs, loading, error };
};

export default useMyFeed;
